import { render, staticRenderFns } from "./SkusWholesalePriceEdit.vue?vue&type=template&id=68fbfa64&"
import script from "./SkusWholesalePriceEdit.vue?vue&type=script&lang=js&"
export * from "./SkusWholesalePriceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports